import { useMutation } from "@tanstack/react-query";
import api from "@/services/api/axios-client";
import {
  DefaultApiAssetsControllerUpdateRequest,
  DefaultApiUploadsControllerUpdateRequest,
} from "generated";

export const useFilesConfirmation = () => {
  const uploadUpdateMutation = useMutation({
    mutationFn: (updateBody: DefaultApiUploadsControllerUpdateRequest) => {
      return api.uploadsControllerUpdate(updateBody);
    },
  });

  const updateAssetMutation = useMutation({
    mutationFn: (updateBody: DefaultApiAssetsControllerUpdateRequest) => {
      return api.assetsControllerUpdate(updateBody);
    },
  });

  const isError = uploadUpdateMutation.isError || updateAssetMutation.isError;
  const isSuccess =
    uploadUpdateMutation.isSuccess || updateAssetMutation.isSuccess;
  const isPending =
    uploadUpdateMutation.isPending || updateAssetMutation.isPending;

  const data = uploadUpdateMutation.data?.data;
  const uploadMutateAsync = uploadUpdateMutation.mutateAsync;
  const assetMutateAsync = updateAssetMutation.mutateAsync;

  return {
    isError,
    isSuccess,
    data,
    uploadMutateAsync,
    assetMutateAsync,
    isPending,
  };
};
